import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalModalService {
  private modalQueue: any[] = [];
  private activeModalSubject = new Subject<any>();
  orderComplete$ = this.activeModalSubject.asObservable();
  private isModalOpen = false;
  private shownOrderIds = new Set<number>();
  private forceCloseSubject = new Subject<void>();
  forceClose$ = this.forceCloseSubject.asObservable();

  showOrderComplete(order: any) {
    if (this.shownOrderIds.has(order.order_id)) return;
    this.shownOrderIds.add(order.order_id);

    this.modalQueue.push(order);
    this.tryShowNext();
  }

  modalClosed() {
    this.isModalOpen = false;
    this.shownOrderIds.clear();
    this.tryShowNext();
  }

  private tryShowNext() {
    if (!this.isModalOpen && this.modalQueue.length > 0) {
      this.isModalOpen = true;
      const next = this.modalQueue.shift();
      this.activeModalSubject.next(next);
    }
  }

  forceClose() {
    this.forceCloseSubject.next();
  }
}
